const DEFAULT_MERCHANDISING_CARDS = [
  'unlimited_swipes',
  'boost',
  'your_profile',
  'who_sees_you',
  'passport',
  'super_like',
  'undo',
  'who_you_see',
  'hide_ads',
] as const;

export default DEFAULT_MERCHANDISING_CARDS;
